<template>
  <div class="app-container">
    <CardList :cards="opciones"></CardList>
  </div>
</template>
<script>
import { CardList } from '@/components';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'home',
  data() {
    return {
      cardList: [
        {
          name: this.$tc('message.home.menu.tasas.titulo', 2),
          detail: this.$t('message.home.menu.tasas.detalle', {
            tipo: this.$options.filters.tipoEmpresaName(
              this.$store.getters.empresaSelected.cdtipemp
            )
          }),
          icon: 'description',
          path: '/tasas'
        },
        {
          name: this.$tc('message.home.menu.cuotas.titulo', 2),
          detail: this.$t('message.home.menu.cuotas.detalle', {
            tipo: this.$options.filters.tipoEmpresaName(
              this.$store.getters.empresaSelected.cdtipemp
            )
          }),
          icon: 'description',
          path: '/cuotas'
        }
      ]
    };
  },
  components: {
    CardList
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [{ text: 'Inicio', to: '/' }],
      menuSelected: '/'
    });
  },
  methods: {
    ...mapActions(['setBreadcrumb'])
  },
  computed: {
    ...mapGetters(['isGasElectricidad', 'empresaSelected']),
    opciones() {
      if (!this.isGasElectricidad) {
        return this.cardList.filter(item => item.path === '/tasas');
      }
      // gas y electricidad
      return this.cardList;
    }
  }
};
</script>
